"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentItemPostDTOSchema = exports.ContentItemGetDTOSchema = void 0;
const zod_1 = require("zod");
const ContentItemGetDTOSchema = zod_1.z.object({
    type: zod_1.z.number(),
    name: zod_1.z.string(),
    path: zod_1.z.string(),
    filename: zod_1.z.string(),
    size: zod_1.z.string(),
});
exports.ContentItemGetDTOSchema = ContentItemGetDTOSchema;
const ContentItemPostDTOSchema = zod_1.z.object({
    type: zod_1.z.number(),
    name: zod_1.z.string(),
    filename: zod_1.z.string(),
    size: zod_1.z.string(),
});
exports.ContentItemPostDTOSchema = ContentItemPostDTOSchema;
